import axiosClient from ".";
class RunGameAPI {
  static run_script() {
    return axiosClient.get("/runscript.json");
  }
  static get_multiplier() {
    return axiosClient.get("/runscript/get_multiplier.json");
  }
}

export default RunGameAPI;
